import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 04D5C9C6-6CE4-4D2E-A759-07933F9B7932
 * name cellphone-arrow-down
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-arrow-down.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const CellphoneArrowDownIcon = createSvgIcon(<><path d="M17,1H7A2,2 0 0,0 5,3V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3A2,2 0 0,0 17,1M17,19H7V5H17V19M16,13H13V8H11V13H8L12,17L16,13Z" /></>, 'CellphoneArrowDownIcon');
export default CellphoneArrowDownIcon